/*
 * Auto-tags ingredient names in the product description's "Ingredients:"
 * list with a tooltip pulled from ingredient-glossary.js. Only scans text
 * that follows a bold "Ingredients:" label, so it never touches marketing
 * copy elsewhere on the page.
 */
(function () {
  'use strict';

  var GLOSSARY = window.LOOT_INGREDIENTS || [];
  if (!GLOSSARY.length) return;

  function normalize(str) {
    return str
      .toLowerCase()
      .replace(/[®™#]/g, '')
      .replace(/\(.*?\)/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Mirrors Shopify's Liquid `handleize` filter, so a slug built here from
  // entry.name lines up with the `id` feature-columns.liquid generates from
  // the matching bold ingredient name on /pages/ingredients.
  function handleize(str) {
    return str
      .toLowerCase()
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function findMatch(token) {
    var norm = normalize(token);
    if (!norm) return null;
    for (var i = 0; i < GLOSSARY.length; i++) {
      var entry = GLOSSARY[i];
      for (var j = 0; j < entry.match.length; j++) {
        if (norm.indexOf(entry.match[j]) !== -1) return entry;
      }
    }
    return null;
  }

  function buildTipEl(entry, label) {
    var span = document.createElement('span');
    span.className = 'ingredient-tip';
    span.tabIndex = 0;
    span.setAttribute('role', 'button');
    span.setAttribute('aria-expanded', 'false');

    span.appendChild(document.createTextNode(label));

    var bubble = document.createElement('span');
    bubble.className = 'ingredient-tip__bubble';
    bubble.setAttribute('role', 'tooltip');

    var strong = document.createElement('strong');
    strong.textContent = entry.name;
    bubble.appendChild(strong);
    bubble.appendChild(document.createTextNode(entry.blurb));

    var link = document.createElement('a');
    link.className = 'ingredient-tip__link';
    link.href = '/pages/ingredients#' + handleize(entry.name);
    link.textContent = 'Learn more';
    bubble.appendChild(link);

    span.appendChild(bubble);
    return span;
  }

  function findIngredientsLabel(container) {
    var boldEls = container.querySelectorAll('strong, b');
    for (var i = 0; i < boldEls.length; i++) {
      var text = boldEls[i].textContent.trim().toLowerCase();
      if (text === 'ingredients:' || text === 'ingredients') return boldEls[i];
    }
    return null;
  }

  function tagIngredientList(container) {
    var labelEl = findIngredientsLabel(container);
    if (!labelEl) return;

    var parentBlock = labelEl.closest('p, li') || labelEl.parentNode;
    if (!parentBlock) return;

    var walker = document.createTreeWalker(parentBlock, NodeFilter.SHOW_TEXT, null);
    var afterLabel = false;
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) {
      if (!afterLabel) {
        if (labelEl.contains(node)) afterLabel = true;
        continue;
      }
      textNodes.push(node);
    }

    var colonStripped = false;
    textNodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      if (!colonStripped) {
        // Some product descriptions put the colon after the closing bold tag
        // (e.g. "<strong>Ingredients</strong>: Sodium...") instead of inside it.
        text = text.replace(/^\s*:\s*/, '');
        colonStripped = true;
      }
      if (!text || !text.trim()) return;

      var parts = text.split(/(,)/);
      var frag = document.createDocumentFragment();

      parts.forEach(function (part) {
        if (part === ',') {
          frag.appendChild(document.createTextNode(','));
          return;
        }
        if (!part) return;

        var leading = (part.match(/^\s*/) || [''])[0];
        var trailing = (part.match(/\s*$/) || [''])[0];
        var core = part.slice(leading.length, part.length - trailing.length);

        if (!core) {
          frag.appendChild(document.createTextNode(part));
          return;
        }

        var endPeriod = '';
        if (/\.\s*$/.test(core)) {
          core = core.replace(/\.\s*$/, '');
          endPeriod = '.';
        }

        var entry = findMatch(core);

        if (leading) frag.appendChild(document.createTextNode(leading));
        frag.appendChild(entry ? buildTipEl(entry, core) : document.createTextNode(core));
        if (endPeriod) frag.appendChild(document.createTextNode(endPeriod));
        if (trailing) frag.appendChild(document.createTextNode(trailing));
      });

      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function positionBubble(tip) {
    var bubble = tip.querySelector('.ingredient-tip__bubble');
    if (!bubble) return;
    bubble.classList.remove('ingredient-tip__bubble--edge-left', 'ingredient-tip__bubble--edge-right');

    var rect = bubble.getBoundingClientRect();
    var margin = 12;
    if (rect.left < margin) {
      bubble.classList.add('ingredient-tip__bubble--edge-left');
    } else if (rect.right > window.innerWidth - margin) {
      bubble.classList.add('ingredient-tip__bubble--edge-right');
    }
  }

  function initInteractions() {
    var tips = document.querySelectorAll('.ingredient-tip');
    if (!tips.length) return;

    tips.forEach(function (tip) {
      tip.addEventListener('mouseenter', function () { positionBubble(tip); });
      tip.addEventListener('focus', function () { positionBubble(tip); });
      tip.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.ingredient-tip__link')) {
          return;
        }
        e.preventDefault();
        var willActivate = !tip.classList.contains('is-active');
        tips.forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-expanded', 'false');
        });
        if (willActivate) {
          tip.classList.add('is-active');
          tip.setAttribute('aria-expanded', 'true');
          positionBubble(tip);
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.ingredient-tip')) return;
      tips.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init() {
    document.querySelectorAll('.description.rte').forEach(tagIngredientList);
    initInteractions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
